import {
    DOCUMENT_SETS_LOAD_REQUESTED,
    DOCUMENT_SETS_LOAD_SUCCEEDED,
    DOCUMENT_SETS_LOAD_FAILED,
    DOCUMENT_SETS_LOAD_CANCELED,
    DOCUMENT_SET_LOAD_REQUESTED,
    DOCUMENT_SET_LOAD_SUCCEEDED,
    DOCUMENT_SET_LOAD_FAILED,
    DOCUMENT_SETS_SET,
    DOCUMENT_SETS_MERGE,
    DOCUMENT_SET_SET,
    DOCUMENT_SET_DELETE_REQUESTED,
    DOCUMENT_SET_DELETE_SUCCEEDED,
    DOCUMENT_SET_DELETE_FAILED
} from './constants';

export function requestLoadDocumentSets() {
    return {
        type: DOCUMENT_SETS_LOAD_REQUESTED,
        payload: {},
        meta: {
            logentries: true
        }
    };
}

export function succeededLoadDocumentSets(response: Record<string, any>) {
    return {
        type: DOCUMENT_SETS_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadDocumentSets(error: Error) {
    return {
        type: DOCUMENT_SETS_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function canceledLoadDocumentSets(error: Error) {
    return {
        type: DOCUMENT_SETS_LOAD_CANCELED,
        payload: {}
    };
}

export function requestLoadDocumentSet(documentSetId) {
    return {
        type: DOCUMENT_SET_LOAD_REQUESTED,
        payload: {
            documentSetId
        },
        meta: {
            logentries: true
        }
    };
}

export function succeededLoadDocumentSet(response) {
    return {
        type: DOCUMENT_SET_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadDocumentSet(error) {
    return {
        type: DOCUMENT_SET_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function setDocumentSets(data: Record<string, any>[]) {
    return {
        type: DOCUMENT_SETS_SET,
        payload: data,
        meta: {
            schemaName: 'documentSets'
        }
    };
}

export function mergeDocumentSets(data: Record<string, any>[]) {
    return {
        type: DOCUMENT_SETS_MERGE,
        payload: data,
        meta: {
            schemaName: 'documentSets'
        }
    };
}

export function setDocumentSet(data: Record<string, any>) {
    return {
        type: DOCUMENT_SET_SET,
        payload: data
    };
}

export function deleteDocumentSet(id: number) {
    return {
        type: DOCUMENT_SET_DELETE_REQUESTED,
        payload: {
            id
        },
        meta: {
            logentries: true
        }
    };
}

export function documentSetDeleted(response: Record<string, any>) {
    return {
        type: DOCUMENT_SET_DELETE_SUCCEEDED,
        payload: response
    };
}

export function failedDeleteDocumentSet(error: Error) {
    return {
        type: DOCUMENT_SET_DELETE_FAILED,
        payload: error,
        error: true
    };
}
